/* Built In Imports */
import React from 'react';

/* External Imports */
import {
    Accordion,
    AccordionButton,
    AccordionItem,
    AccordionPanel,
    Box,
    Image,
    Link,
    Text,
} from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
import { nanoid } from 'nanoid';
/* Services */

/**
 * Renders the Faqsection component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} Faqsection component
 */

const Faqsection = ({ sectionContent, region, language, faqtype }) => {
  const faqContent = sectionContent.body.find(el => el.sectionId == 'Faq');
  const faqOthertext = sectionContent.body.find(
    el => el.sectionId == 'FaqSection'
  );
  const FaqSectionChildren = ({ faqs }) => {
    return (
      <AccordionPanel
        pb={4}
        borderTop="solid 1px rgba(255, 255, 255, 0.3)"
        p={{ base: '22px 25px 35px', md: '15px 45px 35px' }}
        textAlign="left"
        fontFamily="FedraSansStd-book"
        fontSize={{ base: '16px', md: '20px' }}
      >
        {faqs.faqs?.map(elchild => {
          return (
            <Box>
              <Text
                // fontWeight="bold"
                fontFamily="FedraSansStd-medium"
                p="20px 0 0 0"
                // _first={{ paddingTop: '0' }}
              >
                {elchild?.question}
              </Text>
              <Text className="faqanswer">
                {StructuredTextContent(elchild?.answer)}
              </Text>
            </Box>
          );
        })}
      </AccordionPanel>
    );
  };
  return (
    <>
      <Box maxW={{ base: '1024px', '2xl': '1410' }} m="0 auto">
        <Box
          marginTop={{ base: '40px', md: '70px' }}
          marginBottom="20px"
          padding={{ base: '0px 40px 40px', lg: '20px 0' }}
        >
          <Text
            as="h2"
            fontSize={{ base: '24px', lg: '50px' }}
            fontFamily="FedraSansStd-A-medium"
          >
            {faqOthertext?.sectionContent[0]?.titleText}
          </Text>
          <Box fontSize={{ base: '14px', lg: '22px' }}>
            {faqOthertext?.sectionContent[0]?.titleSubtext}
          </Box>
        </Box>
        <Accordion allowToggle m={{ base: '0 25px', lg: 'unset' }}>
          {faqtype != 'two' &&
            faqContent?.sectionContent[0]?.faqs[0]?.faqs?.map((faq, i) => {
              return (
                <AccordionItem
                  border="none"
                  borderRadius="12px"
                  background="#2f2c29"
                  m="0 0 20px 0"
                >
                  {({ isExpanded }) => (
                    <>
                      <h2>
                        <AccordionButton
                          paddingTop="20px"
                          paddingBottom="20px"
                          pl={{ base: '24px', md: '40px' }}
                          pr={{ base: '29px', md: '30px' }}
                        >
                          <Box
                            flex="1"
                            textAlign="left"
                            fontFamily="FedraSansStd-A-medium"
                            fontSize={{ base: '18px', lg: '32px' }}
                            lineHeight="1.2"
                          >
                            {faq.title}
                          </Box>
                          <Image
                            src={`${config.staticPath}/assets/images/down-arrow.svg`}
                            title="arrow"
                            alt="arrow"
                            transform={
                              isExpanded ? 'rotate(-180deg)' : 'rotate(0deg)'
                            }
                            w={{ base: '36px', md: '42px' }}
                          ></Image>
                        </AccordionButton>
                      </h2>
                      <FaqSectionChildren key={nanoid(4)} faqs={faq} />
                    </>
                  )}
                </AccordionItem>
              );
            })}
          {faqtype == 'two' &&
            faqContent?.sectionContent[0]?.faqs?.map((faq, i) => {
              return (
                <AccordionItem
                  border="none"
                  borderRadius="12px"
                  background="#2f2c29"
                  m="0 0 20px 0"
                >
                  {({ isExpanded }) => (
                    <>
                      <h2>
                        <AccordionButton paddingTop="20px" paddingBottom="20px">
                          <Box
                            flex="1"
                            textAlign="left"
                            fontFamily="FedraSansStd-A-medium"
                            fontSize={{ base: '18px', lg: '32px' }}
                            lineHeight="1.2"
                          >
                            {faq.question}
                          </Box>
                          <Image
                            src={`${config.staticPath}/assets/images/down-arrow.svg`}
                            title="arrow"
                            alt="arrow"
                            transform={
                              isExpanded ? 'rotate(-180deg)' : 'rotate(0deg)'
                            }
                            w="25px"
                          ></Image>
                        </AccordionButton>
                      </h2>
                      <AccordionPanel
                        pb={4}
                        borderTop="solid 1px rgba(255, 255, 255, 0.3)"
                        p="20px"
                        textAlign="left"
                        fontFamily="FedraSansStd-book"
                        fontSize={{ base: '16px', md: '20px' }}
                      >
                        <Box>
                          <Text className="faqanswer">
                            {StructuredTextContent(faq?.answer)}
                          </Text>
                        </Box>
                      </AccordionPanel>
                    </>
                  )}
                </AccordionItem>
              );
            })}
        </Accordion>
        {faqOthertext?.sectionContent[1] !== undefined && (
          <Link
            background="#ffbd31"
            borderRadius="7px"
            fontSize={{ base: '20px' }}
            color="#2c2a29"
            fontFamily="FedraSansStd-A-medium"
            padding="15px 30px"
            margin="35px 0 0 0"
            display="inline-block"
            // href={faqOthertext.sectionContent[1]?.linkUrl}
            href={refineUrlDomain(
              faqOthertext.sectionContent[1]?.linkUrl,
              region,
              language
            )}
            target="_blank"
          >
            {faqOthertext.sectionContent[1]?.buttonText}
          </Link>
        )}
      </Box>
      <style global jsx>{`
        .faqanswer a {
          color: #ffbd31;
          text-decoration: underline;
        }
        .faqanswer ul {
          padding: 1em;
          margin: 1em;
        }
      `}</style>
    </>
  );
};

export default Faqsection;
